import React from 'react';

const FeaturedStoreCard = ({ imageUrl, alt = 'Store logo' }) => {
  return (
    <div className="bg-white border border-black/10 rounded-3xl p-6 flex items-center justify-center min-h-[140px] hover:border-black/20 hover:shadow-sm transition-all">
      {imageUrl && (
        <img
          src={imageUrl}
          alt={alt}
          className="max-h-20 max-w-full object-contain"
        />
      )}
    </div>
  );
};

export default FeaturedStoreCard;
